import React from "react";
import Chart from "react-apexcharts";

function ChartSLA(value) {
    console.log(value.data);
    const series = value.data === undefined ? [] : value.data ;
    const options = {
        chart: {
            width: '100%'
        },
        colors: ['#1C3583', '#DD8524' , '#5F7C36' , '#ECC419' , '#2269AE' , '#482080' , '#A83D8E'] , 
        fill: {
            colors: ['#1C3583', '#DD8524' , '#5F7C36' , '#ECC419' , '#2269AE' , '#482080' , '#A83D8E']
        },
        markers: {
            colors:['#1C3583', '#DD8524' , '#5F7C36' , '#ECC419' , '#2269AE' , '#482080' , '#A83D8E']
        },
        labels: ['PBTV', 'Nationwide' , 'Bangkok Jam1&2' , 'In Mall', 'Digital MRT' , 'BigC' , 'Signature' ],
        // dataLabels: {
        //     enabled: true,
        //     enabledOnSeries: undefined,
        //     style: {
        //         colors: ['#fff', '#fff']
        //     } , 
        // },
        dataLabels: {
            enabled: true,
            enabledOnSeries: undefined,
            formatter(val, opts) {
                const name = opts.w.globals.labels[opts.seriesIndex]
                return   [val.toFixed(1) + '%' , name]
              } ,
              textAnchor: 'middle',
              distributed: false,
            style: {
                fontSize: '11px',
                textAlign: "left"
            },
          } ,
    
          stroke: {
            width: 0,
            colors: ["#fff"]
          },
        legend: {
            fontSize: '10px',
            position: "bottom"
        },
        plotOptions: {
            pie: {
                customScale: 1,
                donut: {
                    // size: '100%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: 'Jobs',
                            fontSize: '11px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 400,
                            color: '#41434A',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b
                                }, 0)
                            
                            }
                        }
                    }
                }
            }

        }
    };
    return (
        <Chart options={options} series={series} type="donut" />
    )
}

export default ChartSLA














